import { userInfo } from "@js/api/user";
import { battleInit } from "@js/api/battle";

import { cookie, debounce } from "@js/utils";

export default {
  namespaced: true,
  state: {
    hasLogin: false,
    info: {},
    battleInfo: {},
    isFirst: true,
  },
  mutations: {
    // 当前角色信息
    upDateUserInfo(state, info) {
      state.info = info;
    },
    // 登录状态
    upDateLogin(state, status) {
      state.hasLogin = status;
    },
    upDateCrystal(state, num) {
      let info = state.info;
      info.crystal = num;
      state.info = info;
    },
    // 对战信息
    upDateBattleInfo(state, status) {
      state.battleInfo = status;
    },
    upDateFirst(state, status) {
      state.isFirst = status;
    },
  },
  actions: {
    upDateLogin({ commit }, status) {
      commit("upDateLogin", status);
    },
    async upDateUserInfo({ commit, dispatch, state }, upDateTask = false) {
      // if (upDateTask) {
      //   dispatch("taskInfo/upDateTaskList");
      // }
      let data = await userInfo();
      if (data.status == 200) {
        commit("upDateUserInfo", data.data);
        commit("petInfo/upDatePetInfo", data.data.now_monster_info, {
          root: true,
        });
        // data.data.first_join = 1;
        if (state.isFirst) {
          commit(
            "guidance/upDateBaseGuidance",
            data.data.first_join == 1 || data.data.default_monster_id == 0,
            {
              root: true,
            }
          );
        }
        dispatch("upDateLogin", true);
      }
      // else {
      //   commit("upDateUserInfo", null);
      //   cookie.remove("Authorization");
      //   dispatch("upDateLogin", false);
      // }
    },
    async upDateBattleInfo({ commit, state }) {
      let data = await battleInit(); // 获取竞技场信息
      if (data.status == 200) {
        commit("upDateBattleInfo", data.data);
      }
    },

    upDateFirst({ commit }, status) {
      commit("upDateFirst", status);
    },
  },
};
